import { Routes } from '@angular/router';
import { DefaultLandingLayoutComponent } from './containers/default-landing-layout/default-landing-layout.component';
import { TranslationGuard } from './services/translation.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'rwa',
    pathMatch: 'full',
  },
  {
    path: '',
    component: DefaultLandingLayoutComponent,
    children: [
      {
        path: 'rwa',
        loadChildren: () => import(`./rwa/rwa.module`).then((m) => m.RwaModule),
        canActivate: [TranslationGuard],
      },
      // {
      //   path: ':username',
      //   loadChildren: () => import(`./rwa/rwa.module`).then((m) => m.RwaModule),
      //   canActivate: [TranslationGuard],
      // },
      {
        path: 'terms-conditions',
        loadChildren: () =>
          import(`./terms-conditions/terms-conditions.module`).then(
            (m) => m.TermsConditionsModule
          ),
      },
      // {
      //   path: 'user',
      //   loadChildren: () =>
      //     import(`./user/user.module`).then((m) => m.UserModule),
      // },
    ],
  },
  {
    path: 'not-found',
    component: PageNotFoundComponent,
  },
  { path: '**', redirectTo: 'not-found' },
];
